module.exports = __webpack_public_path__ + "fonts/Epilogue-VariableFont_wght.a0ef6bf.woff2";